
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 302"}},[_c('path',{attrs:{"d":"M1000.93 682.29C999.14 652.48 971.2 635 943 623.88c-.17-3.51-.39-7-.63-10.48a444 444 0 00-284.53-382.68v-60.06l-22.73-7.26a445.79 445.79 0 00-270.33 0L342 170.66v60.06a444 444 0 00-284.52 382.6q-.36 5.2-.63 10.5c-28.19 11-56.17 28.63-57.92 58.5v63.94c0 44.76 58.27 64.5 109.09 76.79 10.42 2.49 21.77 4.91 33.75 7.21a2361.56 2361.56 0 00716.48 0c12-2.28 23.3-4.72 33.75-7.21 50.79-12.21 109.06-31.95 109.06-76.79v-61.09c-.06-.58-.06-1.59-.13-2.88zm-65.32 56.21a200.06 200.06 0 01-58.91 20.76c-9.49 2.25-19.82 4.47-30.79 6.59a2301.22 2301.22 0 01-691.9 0c-11-2.12-21.34-4.31-30.77-6.59a200.08 200.08 0 01-58.93-20.76v-45.74a140.83 140.83 0 0134.33-14.15l23.86-7.29-.71-24.93v-.93c0-9.19.32-18.4 1-27.42a380.92 380.92 0 01221-316.95v187.65q31.95-1.89 65.4-3v-267a381.71 381.71 0 01183.13.36v266.84c22.24.72 44.09 1.73 65.4 3V301.79a380.85 380.85 0 01219.52 316.3c.66 9 1 18.21 1 27.42v.94l-.74 24.92 23.85 7.3a140.49 140.49 0 0134.36 14.15z","data-name":"Group 301"}})])])
          )
        }
      }
    